type Money = string | number | null | undefined;

export type PricedLine = {
	quantity?: Money;
	unitPrice?: Money;
	givenUnitPrice?: Money;
	vatRate?: Money;
	discountPercent?: Money;
};

const num = (v: Money): number => Number(v) || 0;

export const roundMoney = (n: number): number => Math.round(n * 100) / 100;


export function effectiveUnitPrice(line: PricedLine): number {
	const given = num(line.givenUnitPrice);
	if (given > 0) return given;
	return num(line.unitPrice) * (1 - num(line.discountPercent) / 100);
}

export function hasGivenPrice(line: PricedLine): boolean {
	return num(line.givenUnitPrice) > 0;
}

export function computeLineNet(line: PricedLine): number {
	return num(line.quantity) * effectiveUnitPrice(line);
}

export function computeOfferTotals(lines: PricedLine[]): {
	subtotal: number;
	vatTotal: number;
	total: number;
} {
	let subtotal = 0;
	let vatTotal = 0;
	for (const l of lines) {
		const base = computeLineNet(l);
		subtotal += base;
		vatTotal += base * (num(l.vatRate) / 100);
	}
	return {
		subtotal: roundMoney(subtotal),
		vatTotal: roundMoney(vatTotal),
		total: roundMoney(subtotal + vatTotal),
	};
}
